import { render, staticRenderFns } from "./viewfnwj.vue?vue&type=template&id=1742098d&scoped=true&"
import script from "./viewfnwj.vue?vue&type=script&lang=js&"
export * from "./viewfnwj.vue?vue&type=script&lang=js&"
import style0 from "./viewfnwj.vue?vue&type=style&index=0&id=1742098d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1742098d",
  null
  
)

export default component.exports